<template>
	<ui-card icon="fal fa-ballot-check" title="Simulador de Propostas">
		<template #body>
			<ui-load-success
				v-if="loader.overlay"
				:loading="loader.overlayLoading"
				:success="loader.overlaySucess"
			/>

			<div class="area-card">
				<transition name="small-fade">
					<div v-show="loader.body" class="loading-card">
						<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
					</div>
				</transition>

				<div class="internal-header">
					<h2 class="title">Configurações de Etapa e Status</h2>
					<span class="desc"
						>Todas as regras definidas abaixo são globais e serão aplicadas nas
						simulações de todos os empreendimentos.
						<br />
						<br />
						Ao ativar as configurações personalizadas existentes na etapa 2 do
						empreendimento, as regras globais serão sobrepostas pelas regras
						personalizadas de cada empreendimento.</span
					>
				</div>

				<div class="grid-50 pt-2">
					<ui-select-2
						v-model="form.funnel_start.stage_id"
						:data="funnelStagesOptions"
						:loading="false"
						:disabled="false"
						:show-footer="false"
						:search="false"
						label="Ao criar o cliente será movimentado para a etapa:"
						item-label="name"
						return-value="id"
						@input="handlerStatusStart"
					/>

					<ui-select-2
						v-model="form.funnel_start.status_id"
						:data="funnelStatusStart"
						:loading="false"
						:disabled="disableStatusStart"
						:show-footer="false"
						:search="false"
						label="Ao criar o cliente será movimentado para o status:"
						item-label="name"
						return-value="id"
					/>

					<ui-select-2
						v-model="form.funnel_end.stage_id"
						:data="funnelStagesOptions"
						:loading="false"
						:disabled="false"
						:show-footer="false"
						:search="false"
						label="Ao finalizar o guia será movimentado para a etapa:"
						item-label="name"
						return-value="id"
						@input="handlerStatusEnd"
					/>

					<ui-select-2
						v-model="form.funnel_end.status_id"
						:data="funnelStatusEnd"
						:loading="false"
						:disabled="disableStatusEnd"
						:show-footer="false"
						:search="false"
						label="Ao finalizar o guia será movimentado para o status:"
						item-label="name"
						return-value="id"
					/>
				</div>

				<div class="internal-header line-t">
					<h2 class="title">Configurações de Apresentação</h2>
					<span class="desc"
						>Configure os modos presentes no Simulador de Propostas.</span
					>
				</div>

				<ui-util-box-text-slot title="Apresentar no simulador o modo de juros.">
					<ui-switch design="xs" v-model="form.interest" :checked="form.interest" />
				</ui-util-box-text-slot>

				<div class="desc-card">
					Habilite esta opção para que o simulador descreva na proposta se as parcelas
					possuem ou não juros.
				</div>

				<ui-util-box-text-slot title="Apresentar no simulador o modo análise financeira.">
					<ui-switch design="xs" v-model="form.analyze" :checked="form.analyze" />
				</ui-util-box-text-slot>

				<div class="desc-card">
					Habilite esta opção para a visualização financeira detalhada da proposta: valor
					presente, valor futuro, juros, variação e valor total.
				</div>

				<ui-util-box-text-slot title="Habilitar permissionamento de visualização da análise financeira.">
					<ui-switch
						design="xs"
						v-model="form.permission_analysis"
						:checked="form.permission_analysis"
					/>
				</ui-util-box-text-slot>

				<div class="desc-card">
					Ative esta opção para definir quais grupos de usuários terão acesso à análise financeira.
				</div>

				<ui-util-box-text-slot title="Permissionamento da análise financeira.">
					<ui-select-2
						class="custom-width"
						v-model="form.groups_analysis"
						placeholder="Selecione"
						item-label="label"
						return-value="value"
						:show-footer="false"
						:data="userGroups"
						:loading="loader.body"
						:disabled="!form.permission_analysis"
						:search="false"
						multiple
						:design="'mgb-0'"
                	/>
				</ui-util-box-text-slot>

				<div class="desc-card">
					Defina quais grupos de usuários podem visualizar a análise financeira da simulação. Use esta configuração para garantir que apenas os usuários autorizados tenham acesso as informações. 
				</div>

				<ui-util-box-text-slot title="Apresentar no simulador o modo valor da tabela.">
					<ui-switch design="xs" v-model="form.proposal_value" :checked="form.proposal_value" />
				</ui-util-box-text-slot>

				<div class="desc-card">
					Habilite esta opção para a visualização do valor da proposta na simulação.
				</div>

				<ui-util-box-text-slot title="Apresentar o valor de proposta na simulação.">
					<ui-switch design="xs" v-model="form.unity_value" :checked="form.unity_value" />
				</ui-util-box-text-slot>

				<div class="desc-card">
					Este parâmetro permite que o valor da unidade seja visível na simulação da
					proposta.
				</div>

				<ui-util-box-text-slot title="Apresentar no simulador o valor futuro.">
					<ui-switch
						design="xs"
						v-model="form.future_value"
						:checked="form.future_value"
					/>
				</ui-util-box-text-slot>

				<div class="desc-card">
					O simulador, por padrão, preenche o Valor Presente da negociação no campo Valor
					Total da Proposta. Ativar essa opção substitui o uso do Valor Presente pelo
					Valor Futuro no preenchimento deste campo.
				</div>

			
			</div>
		</template>
		<template #fl></template>
		<template #fr>
			<ui-button design="md success" :disabled="!canSubmit" @click="submit">Salvar</ui-button>
		</template>
	</ui-card>
</template>
<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSwitch, uiSelect2, uiSelectV2 } from '@/components/ui/form'
	import { uiUtilBoxTextSlot } from '@/components/ui/form/util'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'
	import { utilMixin, formMixin, alertMixin } from '@/mixins'
	import { getConfig, saveConfig, getStages } from '../../util/methods'
	import { groups } from '@/services/axios'

	const defaultForm = () => ({
		interest: null,
		analyze: null,
		unity_value: null,
		future_value: null,
		proposal_value:null,
		permission_analysis: null,
		groups_analysis: [],
		funnel_start: {
			stage_id: null,
			status_id: null,
		},
		funnel_end: {
			stage_id: null,
			status_id: null,
		},
	})

	const defaultDisabled = () => ({})
	const defaultChecked = () => ({})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		name: 'configuration-reserves-proposal-simulator',

		components: {
			uiCard,
			uiButton,
			uiSelect2,
			uiSwitch,
			uiLoadSuccess,
			uiUtilBoxTextSlot,
			uiLoadIndicator,
			uiSelectV2,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				checked: { ...defaultChecked() },
				loader: { ...defaultLoader() },
				proposalSettings: [],
				funnelStagesOptions: [],
				funnelStatusStart: [],
				funnelStatusEnd: [],
				oldForm: {},
				userGroups: [],
			}
		},

		async created() {
			this.loader.body = true
			
			const { data: allGroups } = await groups.getGroups()

			this.userGroups = allGroups
			.filter(group => group.name !== 'admin' && group.name !== 'system')
			.map(group => ({label: group.nameTrans, value: group.id}));

			const [proposalSettings, funnelStagesOptions] = await Promise.all([
				this.getConfig('proposalSettings', 'value_long'),
				this.getStages(),
			])

			this.proposalSettings = proposalSettings
			this.funnelStagesOptions = funnelStagesOptions

			const simulation = this.proposalSettings.simulation

			this.form.interest = this.$mx_chekIsOne(simulation.interest)
			this.form.analyze = this.$mx_chekIsOne(simulation.analyze)
			this.form.unity_value = this.$mx_chekIsOne(simulation.unity_value)
			this.form.future_value = this.$mx_chekIsOne(simulation.future_value)
			this.form.proposal_value = this.$mx_chekIsOne(simulation.proposal_value)
			this.form.permission_analysis = this.$mx_chekIsOne(simulation.permission_analysis)
			this.form.groups_analysis = simulation.groups_analysis || []
			
			this.form.funnel_start = {
				stage_id: parseInt(simulation.funnel_start.stage_id) || null,
				status_id: parseInt(simulation.funnel_start.status_id) || null,
			}

			this.form.funnel_end = {
				stage_id: parseInt(simulation.funnel_end.stage_id) || null,
				status_id: parseInt(simulation.funnel_end.status_id) || null,
			}

			this.handlerStatusStart(this.form.funnel_start.stage_id, false)
			this.handlerStatusEnd(this.form.funnel_end.stage_id, false)

			this.loader.body = false
			this.$mx_copyOldForm()
		},

		computed: {
			canSubmit() {
				return this.$mx_isFormChanged && !this.loader.body && this.canSubmitFunnel()
			},

			disableStatusStart() {
				return this.isStatusDisable(this.funnelStatusStart)
			},

			disableStatusEnd() {
				return this.isStatusDisable(this.funnelStatusEnd)
			},

			validateProposalSettings() {
				return {
					...this.proposalSettings,
					simulation: {
						...this.proposalSettings.simulation,
						analyze: this.$mx_oneOrZero(this.form.analyze),
						interest: this.$mx_oneOrZero(this.form.interest),
						unity_value: this.$mx_oneOrZero(this.form.unity_value),
						proposal_value: this.$mx_oneOrZero(this.form.proposal_value),
						future_value: this.$mx_oneOrZero(this.form.future_value),
						funnel_start: { ...this.funnelValidate(this.form.funnel_start) },
						funnel_end: { ...this.funnelValidate(this.form.funnel_end) },
						permission_analysis: this.$mx_oneOrZero(this.form.permission_analysis),
						groups_analysis: this.form.groups_analysis,

					},
				}
			},
		},

		methods: {
			getConfig,
			saveConfig,
			getStages,

			handlerStatusStart(id, reset = true) {
				if (reset) this.form.funnel_start.status_id = null
				this.funnelStatusStart = this.getStatusByCustomerId(id)
			},

			handlerStatusEnd(id, reset = true) {
				if (reset) this.form.funnel_end.status_id = null
				this.funnelStatusEnd = this.getStatusByCustomerId(id)
			},

			getStatusByCustomerId(id) {
				if (id && this.funnelStagesOptions.length) {
					const stage = Object.values(this.funnelStagesOptions).find(
						(option) => option.id === parseInt(id),
					)
					return [...stage.status]
				}
				return []
			},

			funnelValidate(funnel) {
				return {
					stage_id: !!funnel.stage_id ? funnel.stage_id.toString() : null,
					status_id: !!funnel.status_id ? funnel.status_id.toString() : null,
				}
			},

			canSubmitFunnel() {
				return (
					((this.funnelStatusStart.length > 0 &&
						this.$mx_hasValue(this.form.funnel_start.status_id)) ||
						(this.funnelStatusStart.length == 0 &&
							!this.$mx_hasValue(this.form.funnel_start.status_id))) &&
					((this.funnelStatusEnd.length > 0 &&
						this.$mx_hasValue(this.form.funnel_end.status_id)) ||
						(this.funnelStatusEnd.length == 0 &&
							!this.$mx_hasValue(this.form.funnel_end.status_id))) &&
					this.$mx_hasValue(this.form.funnel_start.stage_id) &&
					this.$mx_hasValue(this.form.funnel_end.stage_id)
				)
			},

			isStatusDisable(array) {
				return array.length == 0
			},

			async submit() {
				try {
					this.loader.overlay = true
					this.loader.overlayLoading = true

					await this.saveConfig(
						'proposalSettings',
						this.validateProposalSettings,
						'value_long',
					)

					setTimeout(() => {
						this.loader.overlayLoading = false
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.loader.overlay = false
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.overlaySucess = false
					setTimeout(() => {
						this.loader.overlay = false
					}, 1000)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
